import type { Cart } from "./Cart.js";
import { type CartStep, cartStepArray } from "./CartStep.js";
import { fieldsToFillInPerStep } from "./fieldsToFillInPerStep.js";

/**
 * Rollbacks the user if they need to fill in some fields in previous steps.
 * This could happen if back-end validation clears our fields.
 *s
 * @param cart current cart
 * @returns the cart with ensured step
 */
export function ensureCartIsInCorrectStep<T extends Cart>(cart: T): T {
	const stepsWithFields = Object.keys(fieldsToFillInPerStep) as CartStep[];
	const stepsWithFieldsOrdered = stepsWithFields.toSorted(
		(first, second) => cartStepArray.indexOf(first) - cartStepArray.indexOf(second),
	);

	for (const step of stepsWithFieldsOrdered) {
		const stepIndex = cartStepArray.indexOf(step);
		const cartStepIndex = cartStepArray.indexOf(cart.step);
		if (stepIndex >= cartStepIndex) {
			break;
		}

		for (const requiredField of fieldsToFillInPerStep[step].required) {
			if (cart.order[requiredField] === undefined) {
				cart.step = step;
				break;
			}
		}
	}

	return cart;
}
